import React from 'react';
import { Alert, Button, Form } from 'react-bootstrap';
import * as _ from 'lodash'
import IosKey from 'react-ionicons/lib/IosKey'
import config from '../../constants/config';
import { AxiosInstance, unauthorizedRequest } from '../../utils/RequestMethods';
import InputValidate from './InputValidate';
import { validatePassword } from '../../utils/validator';
import ButtonLoading from '../../components/ButtonLoading/ButtonLoading';
import { useImmer } from 'use-immer';
import { defaultValue } from '../../utils/helper';
import { copyObject } from '../../utils';


const styles = {
    left: {
        marginLeft: 0
    },
    required: {
        color: 'red'
    }
}

export interface FieldsRestPassWord {
    password: string
    rePassword: string
}
export type IScreenPasswordResetProps = {
    email: string
    goBack(): void

}

const ScreenPasswordReset: React.FC<IScreenPasswordResetProps> = (props): JSX.Element => {
    const [codePin, setCodePin] = React.useState("");
    const [attempts, setAttempts] = React.useState(0)
    const [isFetching, setIsFetching] = React.useState(false)
    const [successCodePin, setSuccessCodePin] = React.useState(false);
    const [processing, setProcessing] = React.useState<boolean>(false)
    // const [password, setPassword] = React.useState("");
    // const [rePassword, setRePassword] = React.useState("");
    const [validated, setValidated] = React.useState<boolean>(false)
    const [errorCodePin, setErrorCodePin] = React.useState(null);
    const [successValidateForm, setSuccessValidateForm] = React.useState(false);
    const formRef = React.useRef(null)
    const [fields, setFields] = React.useState<FieldsRestPassWord>({
        password: "",
        rePassword: "",
    });
    /**
     *
     * @param text
     * @returns
     */
    const onChangeTextCodePin = async (text) => {
        let verifyCodePin = false;
        if (text.length > 6) {
            return false;
        }
        setCodePin(text)
        if (attempts > 10) {
            props.goBack();
        }
        if (text.length == 6) {
            setIsFetching(true)
            verifyCodePin = await validateCodePin(props.email, text);
            console.log("verifyCodePin", verifyCodePin)
            setIsFetching(false)

            if (verifyCodePin == true) {
                setSuccessCodePin(true)
                // refCodePin.current.showError(true, "invalid");
            } else {
                setAttempts(attempts + 1)
            }
        }

    }



    const validateCodePin = async (email: string, code: string): Promise<boolean> => {
        setProcessing(true)
        setErrorCodePin(null)
        let params = {
            email: email,
            code_pin: code
        }


        return AxiosInstance.post(`${config.url.token}/password/validate`, params).then((res) => {
            setProcessing(false)
            if (res && res.data) {

                // console.log(res.data)
                return true;
            }
            setErrorCodePin("Invalid pin.")
        }).catch((error) => {
            setProcessing(false)
            setErrorCodePin("Invalid pin.")
            console.warn("error", error)
            return false;
        })
    }





    const submitChangePassword = async (): Promise<string> => {

        setProcessing(true)
        let params = {
            email: props.email,
            code_pin: codePin,
            password: fields.password,
            confirm_password: fields.rePassword,
        };

        return AxiosInstance.post(`${config.url.token}/password/reset`, params).then((res) => {
            setProcessing(false)
            if (res && res.data) {
                setTimeout(() => {
                    props.goBack()
                }, 500);
                return 'Your password has been reset.'
            }
        }).catch((error) => {
            setProcessing(false)
            throw new Error(error);
        })
    }

    const checkValidity = (fields) => {
        if (formRef && formRef.current) {
            let validityForm = formRef.current.checkValidity();
            // console.log("validityForm", validityForm)
            return validityForm && (fields.rePassword != "" && fields.rePassword == fields.password)
        }
        return false
    }



    const onChangeFields = (key: string, value: any) => {

        let tempFields = copyObject(fields)
        tempFields[key] = value
        setFields(tempFields)

        setTimeout(() => {
            setSuccessValidateForm(checkValidity(tempFields))
        }, 10);
    }

    const formRestPassowd = (): JSX.Element => {
        return (
            <>

                <Form.Group>
                    <Form.Label>New Password <span style={styles.required}>*</span></Form.Label>

                    <InputValidate
                        required
                        type='password'
                        // pattern="(?=^.{8,}$)((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$"
                        value={`${fields.password}`}
                        onValidate={(value) => {
                            console.log("validatePassword(value)", validatePassword(value))
                            return validatePassword(value)
                        }}
                        onChangeValue={(value) => {
                            onChangeFields("password", value)
                            // setPassword(value)
                        }} />

                    <Form.Control.Feedback type="invalid">
                        {fields.password == "" ? `Required.` : 'Must contain at least one number and one uppercase and lowercase letter, and at least 8 or more characters.'}
                    </Form.Control.Feedback>

                </Form.Group>
                <Form.Group>
                    <Form.Label>Re-enter Password <span style={styles.required}>*</span></Form.Label>

                    <InputValidate
                        required
                        type='password'
                        // pattern="(?=^.{8,}$)((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$"
                        value={`${fields.rePassword}`}
                        onValidate={(value) => {
                            console.log("rePassword", value != "" && value == fields.password && validatePassword(value))
                            return value != "" && value == fields.password && validatePassword(value)
                        }}
                        onChangeValue={(value) => {
                            onChangeFields("rePassword", value)

                        }} />

                    <Form.Control.Feedback type="invalid">
                        {fields.rePassword == "" ? `Required.` : 'Passwords must match.'}
                    </Form.Control.Feedback>
                </Form.Group>


            </>
        )
    }

    return (
        <div>
            <p>Input the pin sent to your email to change your password.</p>
            <hr />
            {/* <Alert variant="success">
                <p>Check your email for password reset instructions.</p>
            </Alert> */}
            <Form noValidate
                ref={formRef}
                validated={validated}>

                {!successCodePin && <>

                    <Form.Group>
                        <Form.Label>Pin <span style={styles.required}>*</span></Form.Label>
                        <Form.Control
                            required
                            disabled={processing}
                            value={`${codePin}`}
                            isInvalid={errorCodePin ? true : false}
                            onChange={(e) => {
                                onChangeTextCodePin(e.target.value)
                            }} />
                        <Form.Control.Feedback type="invalid">
                            {errorCodePin ? errorCodePin : " You must input a valid pin."}
                        </Form.Control.Feedback>
                    </Form.Group>

                </>}
                {successCodePin && formRestPassowd()}
                <ButtonLoading
                    disabled={processing || !successValidateForm}
                    style={styles.left}
                    type="submit"
                    onClickFetching={async (e): Promise<string> => {
                        e.preventDefault();
                        e.stopPropagation()

                        setValidated(true)
                        if (!checkValidity(fields)) {
                            throw new Error("make sure input correct data in inputs.")
                        }
                        return await submitChangePassword()
                    }}
                    variant="success">
                    <IosKey color="white" />
                    &nbsp;
                    Change Password
                </ButtonLoading>
            </Form>
        </div>

    );
}
export default ScreenPasswordReset;
